import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import Swal from 'sweetalert2';
import { IOpcaoAcao } from '../../utils/permissionScreen/permissionScreen.types';
import { ITela } from '../../utils/currentScreen/currentScreen.types';
import { validarTelaAtual } from '../../utils/currentScreen/currentScreen';
import { validarPermissao } from '../../utils/permissionScreen/permissionScreen';
import { Router } from '@angular/router';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type BtnTypes = 'primario' | 'secundario' | 'cadastro' | 'upload';
type NameBtn =
  | 'Cadastrar'
  | 'Fechar'
  | 'Abrir'
  | 'Nova'
  | 'Novo'
  | 'Relatório'
  | 'Exportar'
  | 'Faturar';
@Component({
  selector: 'app-botao',
  templateUrl: './botao.component.html',
  styleUrls: ['./botao.component.scss'],
})
export class BotaoComponent {
  @Input() type: BtnTypes = 'primario';
  @Input() width: string = '';
  @Input() bgColor: string = '';
  @Input() color: string = '';
  @Input() border: string = '';
  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() disabled: boolean = false;
  @Input() buttonType: 'button' | 'submit' | 'reset' = 'submit';
  @Output() fileSelected = new EventEmitter<File | String>();
  @ViewChild('fileInput', { static: false }) fileInput:
    | ElementRef<HTMLInputElement>
    | undefined;

  file: File | null = null;
  fileSrc: string | ArrayBuffer | null = null;

  constructor(
    private router: Router,
    public swalAlert: SwalAlertService
  ) {}

  onFileSelected(event: any) {
    const file: File | null = event.target.files?.[0] ?? null;
    if (file && file.name.split('.').pop()?.toLowerCase() === 'xlsx') {
      this.file = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.fileSrc = reader.result;
        this.fileSelected.emit(reader.result as string);
        this.resetFileInput();
      };
      reader.readAsDataURL(this.file);
    } else if (file && file.name.split('.').pop()?.toLowerCase() === 'pdf') {
      this.file = file;
      this.fileSelected.emit(file);
      this.resetFileInput();
    } else {
      this.swalAlert.showAlert(
        'Atenção!',
        'Tipo de arquivo não permitido. Apenas arquivos no formato .xlsx são aceitos.',
        'warning',
        true,
        false,
        undefined,
        () => {
          if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
          }
        }
      );
    }
  }

  isFileTypeAllowed(file: File): boolean {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    return fileExtension === 'xlsx' || fileExtension === 'pdf';
  }

  resetFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.file = null;
    this.fileSrc = null;
  }

  viewButton(acao: string): boolean {
    const acaoMap: Record<NameBtn, IOpcaoAcao> = {
      Cadastrar: 'incluir',
      Fechar: 'incluir',
      Abrir: 'incluir',
      Novo: 'incluir',
      Nova: 'incluir',
      Relatório: 'exportar',
      Exportar: 'exportar',
      Faturar: 'faturarCliente',
    };

    let telaAtual = this.router.url as ITela;

    const nomeBotao = this.getNomeBotao(acao);
    if (nomeBotao)
      if (acaoMap[nomeBotao]) {
        let telaAtualOpcaoTela = validarTelaAtual(telaAtual);

        if (telaAtualOpcaoTela)
          return validarPermissao(telaAtualOpcaoTela, acaoMap[nomeBotao]);
      }

    return true;
  }

  private getNomeBotao(acao: string): NameBtn | null {
    const nomeBotoes: NameBtn[] = [
      'Cadastrar',
      'Fechar',
      'Abrir',
      'Nova',
      'Novo',
      'Relatório',
      'Exportar',
    ];

    for (const nomeBotao of nomeBotoes) {
      if (acao.includes(nomeBotao)) {
        return nomeBotao;
      }
    }

    return null;
  }
}
